import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetEnrollmentsByRoleType = (
  organizationId,
  roleType,
  { page = 1, limit = 1000 } = {}
) => {
  const offset = (page - 1) * limit
  const endpoint = `/organizations/${organizationId}/enrollments?include=user&filter[role][type]=${roleType}&limit=${limit}&offset=${offset}`
  const query = useApiQuery(
    ['enrollments-by-role-type', organizationId, roleType, page, limit],
    'schools',
    async client => {
      const response = await client.get(endpoint)
      return {
        enrollments: response.data,
        totalCount: Number(
          response.headers?.['x-total-count'] ??
            (Array.isArray(response.data) ? response.data.length : 0)
        )
      }
    },
    {
      enabled: !!organizationId && !!roleType,
      placeholderData: previousData => previousData
    },
    { authenticated: true, version: 4 }
  )

  return {
    data: query.isError ? null : query.data?.enrollments ?? [],
    totalCount: query.isError ? null : query.data?.totalCount ?? null,
    loading: query.isLoading,
    fetching: query.isFetching,
    error: query.isError ? query.error : null,
    getEnrollments: query.refetch
  }
}
